import {AfterViewInit, Component, Directive, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {BsModalRef, BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {environment} from '../../../../../environments/environment';
import {ToastrService} from 'ngx-toastr';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {language} from '../../../../language/vn';
import {CommandUtil} from '../../../../global/commandutil';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {Subject} from 'rxjs';
import {DatePipe} from '@angular/common';
import {VanBanDenFileXL} from '../../../../models/vanbanden/vanbandenfilexl';
import {VanBanDenFileXLService} from '../../../../service/vanbanden/service-vanbandenfilexl';
import {ToTrinhFileNXL} from '../../../../models/totrinh/totrinhfilenxl';
import {ToTrinhFileNXLService} from '../../../../service/totrinh/service-totrinhfilenxl';
import {YeuCauFileNXL} from '../../../../models/yeucau/yeucaufilenxl';
import {YeuCauFileNXLService} from '../../../../service/yeucau/service-yeucaufilenxl';
@Component({
  templateUrl: './file.component.html',

})
export class FileYeuCauComponent implements OnInit, AfterViewInit {
  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public id: number = -1;
  public language = language;
  public  onClose: Subject<boolean>;
  public yeuCauXLFiles: YeuCauFileNXL[] = [];
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[]=[];
  constructor(
    public toastr: ToastrService,
    public bsModalService: BsModalService,
    public datepipe: DatePipe,
    public _bsModalRef: BsModalRef,
    public commandUtil: CommandUtil,
    public yeuCauFileNXLService: YeuCauFileNXLService

  ) {
  }
  ngAfterViewInit() {
  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }

  ngOnInit(): void {
    this.onClose = new Subject();
    this.uploadUrl= this.yeuCauFileNXLService.urlUpload;
    this.deleteUrl= this.yeuCauFileNXLService.urlDelete;

  }
  public edit(id: number) {
    this.id = id;
    let files: ToTrinhFileNXL[] = [];
    this.fileLists =  [];
    this.yeuCauFileNXLService.findAllByMaVBId(id).subscribe(
      x => {
        files = x;
        this.yeuCauXLFiles=x;
        for(let i=0; i< files.length; i++)
        {
          this.fileLists.push({ id: files[i].id,
            title: files[i].name ,
            name: files[i].fileKey,
            size: files[i].size,
            fileType: files[i].width,
            folder: files[i].folder });
        }
        this.uploadFileComponent.uploadCommand["files"]= this.fileLists;
      });

  }
  public actionFile()
  {
    this.uploadFileComponent.id = this.id;
    this.uploadFileComponent.uploadCommand.upload( this.uploadFileComponent.uploadCommand.getFilesData());
    this.toastr.success(language.message_xuly_file_success, language.message);
    this.onSave();
  }

  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }
}

